<template>
    <div>
        <div class=" max-w-5xl mx-auto">
            <osv-cart-payment />
        </div>
    </div>
</template>

<script>
import { ALBIGNY_CONFIG } from "../../assets/allosv.config";
export default {
    mounted() {
        window.__osvConf = ALBIGNY_CONFIG;
    }
}
</script>

<style lang="scss" scoped>
</style>